// extracted by mini-css-extract-plugin
var _1 = "mrUs0";
var _2 = "lUg7a";
var _3 = "Wzfug";
var _4 = "KxBDV";
var _5 = "zpVY4";
export { _1 as "content", _2 as "details", _3 as "showWhenClosed", _4 as "showWhenOpen", _5 as "summary" }
